import { ButtonMenu, useModal } from "@homebound/beam";
import { ProjectsForLotSequenceFragment } from "src/fragments/circularFragments.generated";
import { DevelopmentProjectDetailFragment } from "src/routes/developments/DevelopmentAllLots.generated";
import { useCohortDevelopmentsQuery } from "src/routes/developments/lot-summary/sequence-sheet/components/move-project-button-menu/MoveProjectButtonMenu.generated";
import { createCohortButtonMenuItems } from "../utils";

type MoveProjectButtonMenuProps = { project: ProjectsForLotSequenceFragment | DevelopmentProjectDetailFragment };

export function MoveProjectButtonMenu({ project }: MoveProjectButtonMenuProps) {
  const { openModal } = useModal();
  const { data } = useCohortDevelopmentsQuery({ fetchPolicy: "cache-first" });
  const { cohorts } = data || { cohorts: [] };

  return (
    <ButtonMenu trigger={{ icon: "arrowFromLeft" }} items={createCohortButtonMenuItems(cohorts, project, openModal)} />
  );
}
